import { render, staticRenderFns } from "./permissionTree.vue?vue&type=template&id=6f8a1b98&scoped=true"
import script from "./permissionTree.vue?vue&type=script&lang=js"
export * from "./permissionTree.vue?vue&type=script&lang=js"
import style0 from "./permissionTree.vue?vue&type=style&index=0&id=6f8a1b98&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f8a1b98",
  null
  
)

export default component.exports